import {
  FINISH_LOADING_APPLICATION, RLTD_ACC_NOT_AVL,
  SET_SIMULATED_BUSINESS_ACTIVITIES,
  START_LOADING_APPLICATION,
} from "../action";
import { getBusinessActivities } from "../api/api";

export const loadSimulatedBusinessActivities = (userId) => async (dispatch) => {
  dispatch({ type: START_LOADING_APPLICATION });
  try {
    const businessActivities = await getBusinessActivities(userId);

    if(businessActivities) {
      dispatch({
        type: SET_SIMULATED_BUSINESS_ACTIVITIES,
        payload: businessActivities,
      });
    }else{
      dispatch({ type: RLTD_ACC_NOT_AVL });
      dispatch({ type: FINISH_LOADING_APPLICATION });
    }
  } catch (error) {
    console.error("Error while loading simulated business activities:", error);
    dispatch({ type: RLTD_ACC_NOT_AVL });
    dispatch({ type: FINISH_LOADING_APPLICATION });
  } finally {
    dispatch({ type: FINISH_LOADING_APPLICATION });
  }
};
